<template>
  <div></div>
</template>

<script lang="ts" setup>
import { isClient } from '/@shared/app'
import {
  getCookieFromString,
  getCookieExiresDateString,
  getCurrentDomain,
} from '/@shared/utils'

function setRefferer() {
  // in backend repository
  // src/fornex/src/js/save-referer.ts

  const cookieString = document.cookie
  const domain = getCurrentDomain()

  function getParam(p: string) {
    const match = RegExp('[?&]' + p + '=([^&]*)').exec(location.search)
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
  }

  const ref = (document.referrer.match(/\/\/(.*?)\//) || [])[1]
  const partner_ref = getParam('server')
  const gclid = getParam('gclid')

  const passignParams = ['utm_source', 'utm_medium', 'utm_campaign']

  for (const name of passignParams) {
    const value = getParam(name)
    if (value && !getCookieFromString(cookieString, name)) {
      document.cookie = `${name}=${value}; domain=.${domain}; expires=${getCookieExiresDateString(30)}`
    }
  }

  if (
    ref &&
    ref !== document.location.host &&
    !getCookieFromString(cookieString, 'referer')
  ) {
    document.cookie = `referer=${ref}; domain=.${domain}; expires=${getCookieExiresDateString(60)}`
  }

  if (partner_ref) {
    document.cookie = `partner_ref=${partner_ref}; domain=.${domain}; expires=${getCookieExiresDateString(60)}`
  }

  if (gclid) {
    const gclsrc = getParam('gclsrc')
    if (!gclsrc || gclsrc.indexOf('aw') !== -1) {
      document.cookie = `gclid=${gclid}; domain=.${domain}; expires=${getCookieExiresDateString(90)}`
    }
  }
}

if (isClient) setRefferer()
</script>
